import kr from '../kr/kr';

export default class MainMenus extends kr.Component {
    init() {
        this.handleLangMenu();
    }

    toggleMenuList() {
        const menus = document.querySelectorAll('.fake-select');

        menus.forEach(el=>{
            el.addEventListener('click', event=> {
                el.classList.contains('currency-menu__active') ? el.classList.remove('currency-menu__active') : el.classList.add('currency-menu__active');
                el.childNodes[3].value = event.target.getAttribute('data-value');
                if(!event.target.classList.contains('fake-select') && !event.target.classList.contains('currency-menu__placeholder') && !event.target.classList.contains('currency-menu__fake-select')) {
                    el.children[0].children[0].children[0].innerText = event.target.innerText;
                }
            })
        })
    }

    fakeDropdownTogglers() {
        const menuButton = document.querySelector('.currency-menu__button');
        const menuLayerToggler = document.querySelector('.footer__currency-menu');
        if (!menuButton) {
            return;
        }
        menuButton.addEventListener('click', ()=> {
            menuLayerToggler.classList.contains('currency-menu-opened') ? menuLayerToggler.classList.remove('currency-menu-opened') : menuLayerToggler.classList.add('currency-menu-opened');
        })
    }

    handleLangMenu() {
        this.toggleMenuList();
        this.fakeDropdownTogglers();
    }
}

kr.registerComponent('.currency-menu__main', {
    component: MainMenus
});
